var _defs, _polyline, _path, _path2, _rect, _path3, _path4, _path5, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f7d6c58f-73fb-45b8-af49-309fc28b0836",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a9c45720-e112-42a9-86e5-d2e739aab611,.bf1d8b5c-52d7-4c68-8abb-c2d3215ce054{fill:none;}.a9c45720-e112-42a9-86e5-d2e739aab611{stroke:#645346;}.a9c45720-e112-42a9-86e5-d2e739aab611,.afed2409-25db-4346-b2b7-d56518be2748,.bf1d8b5c-52d7-4c68-8abb-c2d3215ce054{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.afed2409-25db-4346-b2b7-d56518be2748,.bf1d8b5c-52d7-4c68-8abb-c2d3215ce054{stroke:#8e8e8e;}.afed2409-25db-4346-b2b7-d56518be2748,.bf990433-612b-4dc3-9ee1-b26bd83d2db3{fill:#3ba595;}.ae47c719-cc02-460f-a0cd-23cb718afbf6{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "xls") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a9c45720-e112-42a9-86e5-d2e739aab611",
    points: "37.1 24.3 63.2 24.3 63.2 53.5 30.6 53.5 30.6 32.6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bf1d8b5c-52d7-4c68-8abb-c2d3215ce054",
    d: "M22.3,78.2a4.1,4.1,0,0,0,4.1,4.2H67.3a4.2,4.2,0,0,0,4.2-4.2V21.8a4.2,4.2,0,0,0-4.2-4.2H36.7L22.3,32.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "afed2409-25db-4346-b2b7-d56518be2748",
    d: "M22.3,32.1H32.6A4.1,4.1,0,0,0,36.7,28V17.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bf990433-612b-4dc3-9ee1-b26bd83d2db3",
    x: 32.8,
    y: 59.5,
    width: 44.9,
    height: 14.99,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ae47c719-cc02-460f-a0cd-23cb718afbf6",
    d: "M49.9,72.3l-1.3-2.2-1.1-2h-.1a12.2,12.2,0,0,1-1,2l-1.3,2.2H43.6l3.1-5.1-2.9-5h1.5l1.3,2.4a14.7,14.7,0,0,1,.9,1.7h.1a14,14,0,0,1,.9-1.7l1.4-2.4h1.5l-3.1,4.9,3.1,5.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ae47c719-cc02-460f-a0cd-23cb718afbf6",
    d: "M53,62.2h1.3v9h4.3v1.1H53Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ae47c719-cc02-460f-a0cd-23cb718afbf6",
    d: "M59.9,70.7a3.9,3.9,0,0,0,2.3.7c1.3,0,2.1-.7,2.1-1.7s-.5-1.5-1.9-2-2.7-1.5-2.7-2.9S61,62.1,63,62.1a4,4,0,0,1,2.2.5l-.3,1a4,4,0,0,0-1.9-.5,1.7,1.7,0,0,0-1.9,1.6c0,.9.6,1.4,2,1.9s2.5,1.5,2.5,3-1.1,2.9-3.5,2.9a5,5,0,0,1-2.6-.7Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a9c45720-e112-42a9-86e5-d2e739aab611",
    x1: 36.7,
    y1: 53.5,
    x2: 36.7,
    y2: 24.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a9c45720-e112-42a9-86e5-d2e739aab611",
    x1: 30.6,
    y1: 32.1,
    x2: 63.2,
    y2: 32.1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a9c45720-e112-42a9-86e5-d2e739aab611",
    x1: 30.6,
    y1: 42.9,
    x2: 63.2,
    y2: 42.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.b2e99309956d37f74fe59dd9758d5bac.svg";
export { ForwardRef as ReactComponent };